<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Bulk Reallocation</strong>
          </div>
          <b-row class="mt-2 mb-2">
            <b-col md="6">
              <b-col sm="12">
                <b-form-group>
                  <b-row>
                    <b-col sm="4">
                      <label for="Select Vehicle From"><b>Select Vehicle From</b></label>&nbsp;<span style="color: red;">*</span>
                    </b-col>
                    <b-col sm="8">
                      <!-- <b-form-select v-model="customer.vehicle_id" id="vechicle_from" name="vehicle_id" :class="{'input': true, 'text-danger': errors.has('form-1.vehicle_id') }" v-on:change="getvehiclelistto();">
                          <option :value="selected" >--Select--</option>
                          <option :value="customer.vehicle_id"  v-for="customer in data1" v-bind:value="customer.vehicle_id">{{ customer.vehicle_name}} - {{ customer.vehicle_no}}</option>
                      </b-form-select>  -->

                        <v-select
                        v-model="customer.vehicle_id"
                        id="vechicle_from"
                        name="vehicle_id"
                        :class="{
                          input: true,
                          'text-danger': errors.has('form-1.vehicle_id'),
                        }"
                        v-on:change="getvehiclelistto(customer.vehicle_id)"
                        :options="data1"
                        placeholder="-- Select --"
                      ></v-select>
                      <span
                        style="width: 270px;"
                        v-show="errors.has('form-1.vehicle_id')"
                        class="help text-danger"
                        >{{ errors.first("form-1.vehicle_id") }}</span
                      >
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-col>

            <b-col md="5">
              <b-form-group>
                <b-row>
                  <b-col sm="4">
                    <label for="Select Vehicle To"><b>Select Vehicle To</b></label>&nbsp;<span style="color: red;">*</span>
                  </b-col>
                  <b-col sm="8">
                    <v-select
                      v-model="customer1.vehicle_id"
                      id="vehicle_to"
                      name="vehicle_id"
                      :class="{
                        input: true,
                        'text-danger': errors.has('form-1.vehicle_id'),
                      }"
                      v-on:change="setSelectedid(customer1.vehicle_id)"
                      :options="data2"
                      placeholder="-- Select --"
                    ></v-select>
                    <span
                      style="width: 270px;"
                      v-show="errors.has('form-1.vehicle_id')"
                      class="help text-danger"
                      >{{ errors.first("form-1.vehicle_id") }}</span
                    >
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <!-- <a href="#" target="_blank">
                    <b-button size="md" 
                    style="float: right; display:block;" v-if="customer1.vehicle_id != undefined && value_vehicle != null"> 
                    <i class="fa fa-download" aria-hidden="true"></i>
                    Download Eway Bill
                  </b-button>
                  </a> -->
              <!-- <span v-if="customer1.vehicle_id != undefined && value_vehicleid != null && ewaybillipdf == ''"><b style="color: red; float: right;">
                    No Eway Bill List Found
                  </b>
                  <br></span> -->
              <b-button
                size="sm"
                @click="EwaybillList()"
                v-if="
                  customer1.vehicle_id != undefined && value_vehicleid != null
                "
                :disabled="ewaybillipdf == ''"
                style="float:right;"
                ><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                Download Eway Bill
              </b-button>
              <!-- <a :href="ewaybillipdf" target="_blank"><b-button size="md" 
                    style="float: right; display:block;" v-if="customer1.vehicle_id != undefined && value_vehicleid != null"  :disabled="ewaybillipdf == ''"> <i class="fa fa-download" aria-hidden="true"></i>
                    Download Eway Bill</b-button></a> -->
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="12">
              <div>
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item">
                    <a
                      @click="activeTab = 1"
                      class="nav-link"
                      :class="{ active: isActiveTab(1) }"
                      >Assigned</a
                    >
                  </li>

                  <li class="nav-item">
                    <a
                      @click="activeTab = 2"
                      class="nav-link "
                      :class="{ active: isActiveTab(2) }"
                      >In-Transit</a
                    >
                  </li>

                  <li class="nav-item">
                    <a
                      @click="activeTab = 3"
                      class="nav-link "
                      :class="{ active: isActiveTab(3) }"
                      >OFD</a
                    >
                  </li>
                </ul>
              </div>
            </b-col>

            <b-col md="12">
              <div class="tab-panel" v-if="isActiveTab(1)">
                <bulkassigned style="width:70%;"></bulkassigned>
              </div>

              <div class="tab-panel" v-if="isActiveTab(2)">
                <bulkintransit style="width:70%;"></bulkintransit>
              </div>

              <div class="tab-panel" v-if="isActiveTab(3)">
                <bulkofd style="width:70%;"></bulkofd>
              </div>
            </b-col>
          </b-row>

          <b-modal
            v-model="openmodels"
            hide-footer
            title="Eway Bill Details"
            size="lg"
          >
            <div class="d-block text-center">
              <b-table
                show-empty
                responsive
                :items="ewaybillitem"
                :busy="isBusyeway"
                :current-page="currentPage"
                :fields="ewayfields"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :bordered="bordered"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                <template slot="ewaybillpdf" slot-scope="row">
                  <div>
                    <a :href="row.item.ewaybillpdf" target="_blank"
                      ><b-button size="sm">
                        <i class="fa fa-download" aria-hidden="true"></i>
                        Download</b-button
                      ></a
                    >
                  </div>
                </template>
              </b-table>
            </div>
            <b-button
              class="mt-3 float-right"
              variant="danger"
              @click="hideModal"
              >Close Me</b-button
            >
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";

import bulkassigned from "./bulkassigned.vue";
import bulkofd from "./bulkofd.vue";
import bulkintransit from "./bulkintransit.vue";
import bulkndr from "./bulkndr.vue";
import Bulkintransit from "./bulkintransit.vue";

export default {
  data: function() {
    return {
      activeTab: "",
      bulkassigned,
      bulkofd,
      bulkintransit,
      id: "",
      customer: {},
      customer1: {},
      bulkndr,
      data1: [],
      data2: [],
      vehicleFrom: "",
      selected: "",
      name: "bulkallocation",
      value: "",
      value_vehicleid: "",
      openmodels: false,
      ewaybillitem: [],
      ewayfields: [
        { key: "parentawb", label: "Parent AWB" },
        { key: "ebn", label: "EBN" },
        { key: "invoiceno", label: "Invoice No" },
        { key: "ewaybillpdf", label: "Eway Bill PDF" },
      ],
      ewaytotalRows: "",
      isBusyeway: false,
    };
  },
  components: {
    bulkassigned,
    bulkofd,
    bulkndr,
    bulkintransit,
  },

  created: function() {
    //this.isActiveTab(1);
    this.getdeliveragentlistfrom();
  },

  methods: {
    getdeliveragentlistfrom: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const deliveryagent = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        isactive: "1",
        vehicle_type: "bulkreallocate",
        // deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
      };
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`, deliveryagent)
        .then((result) => {
          this.data1 = result.body;
          // console.log(this.data1)
          var data = [];

          result.body.forEach(function(srData) {
            data.push({
              key: srData.vehicle_id,
              label: srData.vehicle_no + "-" + srData.vehicle_name,
            });
          });
          this.data1 = data;
          // console.log(this.data1)
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    getactiveTab: function() {
      var activeTab = "";
      // var activetabcount='';

      var vehicleid_from = document.getElementById("vechicle_from").value;

      console.log("vehicleid_from", vehicleid_from);

      if (this.activeTab == 3) {
        this.activeTab = 3;
        this.isActiveTab(activeTab);
      } else if (this.activeTab == 2) {
        this.activeTab = 2;
        this.isActiveTab(activeTab);
      } else {
        this.activeTab = 1;
        this.isActiveTab(activeTab);
      }
    },

    getvehiclelistto: function(data) {
      var activeTab = "";
      this.activeTab = 0;
      this.isActiveTab(activeTab);

      // localStorage.setItem("vehicle_id", this.customer.vehicle_id);

      var userdata = localStorage.getItem("userData");
      document.getElementById("vechicle_from").value = data.key;
      var vehicleid_from = document.getElementById("vechicle_from").value;
      this.vehicleFrom = vehicleid_from;
      console.log("vehicleid_from1", vehicleid_from);
      var userInfo = JSON.parse(userdata);

      const vehicleagent = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        isactive: "1",
        vehicle_type: "bulkreallocate",
        // vehicleid: `${vehicleid_from}`,
      };

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`, vehicleagent)
        .then((result) => {
          // this.isBusy = true;
          this.data2 = result.body;
          var data = [];

          result.body.forEach(function(srData) {
            data.push({
              key: srData.vehicle_id,
              label: srData.vehicle_no + "-" + srData.vehicle_name,
            });
          });
          this.data2 = data;
          // console.log(this.data2)
          this.getactiveTab();
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    setSelectedid: function(value) {
      console.log("value", value);
      this.value_vehicleid = value;
      if (this.customer1.vehicle_id != undefined) {
        //alert(this.customer1.deliveryagentmasterid);
        localStorage.setItem("vehicleidto", this.customer1.vehicleid);
        document.getElementById("vehicle_to").value = value.key;
        // var vehicleid_from= document.getElementById('vechicle_from').value;
        var x = value.key;
        // console.log(value)
        // console.log("this.customer1.vehicleid",this.customer1.vehicleid)
        console.log(x);
        // this.EwaybillList();
      } else {
        document.getElementById("vehicle_to").value = undefined;
      }
    },

    isActiveTab(id) {
      return this.activeTab === id;
    },

    // EwaybillList : function () {
    //   var userdata = localStorage.getItem("userData");
    //     var userInfo = JSON.parse(userdata);
    //     const Obj={
    //       tripid: `${this.customer1.vehicle_id.key}`,
    //     }
    //     console.log("obj",Obj)
    //     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getEwaybillListAndDownload`,Obj).then((result)=>{
    //         console.log("Result",result);
    //         if (result.body.returnmsg === 'Successful') {
    //           this.ewaybillitem=result.body.returnvalue;
    //           console.log("ewaybillitem",this.ewaybillitem)
    //           this.ewaybillipdf=this.ewaybillitem[0].ewaybillpdf;
    //           console.log("ewaybillipdf",this.ewaybillipdf)
    //         }else{
    //           this.ewaybillitem=[];
    //           this.ewaybillipdf = '';
    //         }
    //     })
    // },

    EwaybillList: function() {
      this.openmodels = true;
      this.isBusyeway = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const Obj = {
        tripid: `${this.customer1.vehicle_id.key}`,
      };
      console.log("obj", Obj);
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getEwaybillListAndDownload`, Obj)
        .then((result) => {
          console.log("Result", result);
          this.isBusyeway = false;
          if (result.body.returnmsg === "Successful") {
            this.ewaybillitem = result.body.returnvalue;
            console.log("ewaybillitem", this.ewaybillitem);
            this.ewaytotalRows = result.body.returnvalue.length;
          } else {
            this.ewaybillitem = [];
            this.ewaytotalRows = 0;
          }
        });
    },

    hideModal: function() {
      this.openmodels = false;
    },
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
